import { mobileMaxMediaQuery } from './constants';

export const isMobileSize = (): boolean => window.matchMedia(mobileMaxMediaQuery).matches;
export const isDesktopSize = (): boolean => !window.matchMedia(mobileMaxMediaQuery).matches;
